var map = {
	"./Airship_Exhibit.webp": 59214,
	"./Alabaster_Idol.webp": 40638,
	"./Amphitheatre.webp": 89626,
	"./Ancient_Library.webp": 5882,
	"./ArabiaGoods.webp": 10522,
	"./ArabiaWorker.webp": 4286,
	"./Arc_Gate.webp": 72556,
	"./Architect_Studio.webp": 6080,
	"./Astronomer.webp": 15910,
	"./AztecCrocodile.webp": 20065,
	"./Aztec_Main_Temple.webp": 34615,
	"./Banyan_Tree.webp": 60910,
	"./Barrel.webp": 7622,
	"./Basket_Drying_Rack.webp": 29712,
	"./Bastion.webp": 64710,
	"./Bazaar.webp": 58161,
	"./Bird_House.webp": 7122,
	"./Blueprint-Colosseum.webp": 7418,
	"./Blueprint-Hagia_Sophia.webp": 11531,
	"./Blueprint-Hanging_Gardens.webp": 12633,
	"./Blueprint-Palace_of_Aachen.webp": 27999,
	"./Blueprint-Statue_of_Zeus.webp": 36044,
	"./Blueprint-Stonehenge.webp": 66952,
	"./Blueprint-Temple_of_Artemis.webp": 46791,
	"./Bronze_Bracelet.webp": 11167,
	"./Cape.webp": 61857,
	"./Carcassonne.webp": 60730,
	"./Cartwheel.webp": 25335,
	"./Cavalry.webp": 72516,
	"./Celtic_Arch.webp": 68743,
	"./Celtic_Broch.webp": 54543,
	"./Chili.webp": 16879,
	"./ChinaGoods.webp": 79177,
	"./Cinnamon.webp": 89273,
	"./Coin.webp": 95299,
	"./Column.webp": 72192,
	"./CommanderSlot.webp": 29436,
	"./Commander_Tower.webp": 32758,
	"./Compass.webp": 64826,
	"./CrocsBoost.webp": 24877,
	"./Crypt_Of_The_Count.webp": 73714,
	"./Culture_Bonus.webp": 37348,
	"./Culture_Range.webp": 29822,
	"./DockWorker.webp": 14063,
	"./DockWorkerBoost.webp": 88222,
	"./Door.webp": 80618,
	"./Dovecote_Tower.webp": 99121,
	"./Draculas_Castle.webp": 68418,
	"./Druid_Grove.webp": 28690,
	"./Drum_Tower.webp": 59064,
	"./EgyptGoods.webp": 73337,
	"./Elixirs.webp": 35586,
	"./Elysian_Field.webp": 67262,
	"./Embellishments.webp": 6332,
	"./Exhibition.webp": 50779,
	"./Expansion.webp": 91339,
	"./Fine_Jewelry.webp": 95051,
	"./Food.webp": 82814,
	"./Fountain_Of_Youth.webp": 27154,
	"./Gate_of_All_Nations.webp": 60948,
	"./Gears.webp": 29550,
	"./Goblet.webp": 97079,
	"./Gold_Laurel.webp": 6712,
	"./Goods.webp": 12856,
	"./Grand_Smithy.webp": 76715,
	"./Great_Garden.webp": 26209,
	"./Grimoire.webp": 60232,
	"./Griot_Court.webp": 16257,
	"./HeavyInfantry.webp": 8036,
	"./Herbs.webp": 15850,
	"./Hot_Air_Balloon.webp": 10766,
	"./Hydra_Monument.webp": 53318,
	"./ImperialGuard.webp": 56328,
	"./Ink.webp": 46510,
	"./Iron_Pendant.webp": 68389,
	"./Lead_Glass.webp": 67659,
	"./LightInfantry.webp": 91223,
	"./Linen_Shirt.webp": 67093,
	"./Mad_Scientists_Lab.webp": 5782,
	"./Madrasa.webp": 78493,
	"./Manuscript.webp": 75346,
	"./Marble_Bust.webp": 27686,
	"./MayaArcher.webp": 17233,
	"./MayaGoods.webp": 32240,
	"./Mead.webp": 99017,
	"./Midnight_Clock.webp": 18839,
	"./Minoan_Watchtower.webp": 92353,
	"./Mongolian_Feast.webp": 3326,
	"./Mongolian_Mother_Tree.webp": 51737,
	"./Mongolian_Saddler.webp": 79954,
	"./Mosaic.webp": 69282,
	"./Mosaic_Bath.webp": 33422,
	"./Museum.webp": 53382,
	"./Natural_History_Museum.webp": 97993,
	"./Ointment.webp": 14980,
	"./Parchment.webp": 6554,
	"./Pepper.webp": 90934,
	"./Persian_Palace.webp": 40859,
	"./Pirate_Fortress.webp": 4942,
	"./Planks.webp": 431,
	"./Puzzle_Chest.webp": 11520,
	"./Quintennial_Monument.webp": 7026,
	"./RP.webp": 97592,
	"./Ranged.webp": 28973,
	"./Royal_Temple.webp": 72603,
	"./Sacred_Marae.webp": 38007,
	"./Saffron.webp": 56573,
	"./Salt.webp": 41586,
	"./School.webp": 36002,
	"./Secretary_Desk.webp": 56592,
	"./Shiraz_Wine_House.webp": 23860,
	"./Shrine_Of_Reflection.webp": 97041,
	"./Siege.webp": 51545,
	"./Silver_Ring.webp": 44374,
	"./Sleigh_Station.webp": 86863,
	"./Stained_Glass.webp": 54217,
	"./StatCap.webp": 30208,
	"./StatCritical.webp": 69605,
	"./StatDamage.webp": 90770,
	"./StatHaste.webp": 17323,
	"./StatHealth.webp": 58026,
	"./StatRecruitmentTime.webp": 43175,
	"./StatSpeed.webp": 53019,
	"./Stone_Tablet.webp": 45712,
	"./Temple_Gate.webp": 79683,
	"./The_Aqueduct.webp": 53146,
	"./Tiki_Statue.webp": 29414,
	"./Toga.webp": 73283,
	"./Tome.webp": 37021,
	"./TradeOffer.webp": 20738,
	"./Traveling_Yurt.webp": 12723,
	"./Treasure_Wreck.webp": 53498,
	"./Trojan_Horse.webp": 25492,
	"./Tunic.webp": 45261,
	"./Unknown.webp": 93360,
	"./Victorian_Conservatory.webp": 53011,
	"./Wardrobe.webp": 7250,
	"./Wax_Seal.webp": 34406,
	"./Winter_Bakery.webp": 29484,
	"./Winter_Market.webp": 97568,
	"./Winter_Pavilion.webp": 47900,
	"./WonderHelpAction.webp": 71112,
	"./WonderHelpRequest.webp": 5039,
	"./Woodhenge.webp": 59870,
	"./Wool.webp": 76651,
	"./Worker.webp": 15844,
	"./Yurt_Of_The_Khan.webp": 32331,
	"./skin.webp": 92959,
	"./skinned.webp": 72318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21069;